<div *ngIf="isLoading" class="loading-overlay">
    <mat-spinner *ngIf="isLoading"></mat-spinner>
</div>

<div style="padding: 10px;">
    <div style="padding: 10px; margin-bottom: 10px; text-align: left;">
        <span style="font-size: x-large; font-weight: bold;">Manage Roles</span>

        <span style="float:right;">
            <button mat-raised-button color="primary" style="margin-left: 10px;" (click)="addRole()">New Role</button>
        </span>
    </div>

    <mat-card appearance="outlined" class="mat-mdc-elevation-specific mat-elevation-z8" style="width: 100%;">
        <div class="table-container">
            <table mat-table [dataSource]="roles">

                <ng-container matColumnDef="name">
                  <th mat-header-cell *matHeaderCellDef> Role Name </th>
                  <td mat-cell *matCellDef="let roleRow"> {{roleRow.role.name}} </td>
                </ng-container>

                <ng-container matColumnDef="description">
                  <th mat-header-cell *matHeaderCellDef> Role Description </th>
                  <td mat-cell *matCellDef="let roleRow"> {{roleRow.role.description}} </td>
                </ng-container>

                <ng-container matColumnDef="tables">
                  <th mat-header-cell *matHeaderCellDef> Included Tables </th>
                  <td mat-cell *matCellDef="let roleRow"> {{roleRow.tablesString}} </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true;"></tr>
                <tr mat-row *matRowDef="let row; let i=index; columns: displayedColumns;" class="table-row" (click)="rowClicked(i)"></tr>
            </table>
        </div>
    </mat-card>
</div>